import { SupervisorActivityOrganizationTree } from '@/features/supervisor/components/SupervisorActivityOrganizationTree';
import { SupervisorTeamRailFrame } from '@/features/supervisor/components/SupervisorTeamRailFrame';
import { useMatch } from '@tanstack/react-router';

/** Secondary navigation owned by the Field activity route. */
export function SupervisorActivityRail() {
  const match = useMatch({ from: '/_authenticated/_app/supervisor/team/field-activity' });

  return (
    <SupervisorTeamRailFrame search={match.search}>
      <SupervisorActivityOrganizationTree search={match.search} />
    </SupervisorTeamRailFrame>
  );
}
